import { Link } from "react-router-dom";
import { ArrowUpRight, Users, Luggage } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Kinetic";
import SpotlightCard from "@/components/SpotlightCard";
import { FLEET, IMG } from "@/data/site";

export default function Fleet() {
  return (
    <main data-testid="page-fleet" className="pt-20">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={IMG.suvs}
            alt=""
            aria-hidden="true"
            className="h-full w-full object-cover object-center opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-obsidian-900/70 via-obsidian-900/85 to-obsidian-900" />
        </div>
        <div className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:px-12 lg:py-32">
          <Reveal>
            <Eyebrow>The Fleet</Eyebrow>
            <h1 className="mt-6 max-w-3xl font-display text-5xl font-semibold leading-[1.05] text-ivory sm:text-6xl">
              Two Suburbans. <em className="gold-text italic">One standard.</em>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-ivory/70">
              Chevrolet Suburban Premier — detailed before every ride, stocked
              with water and chargers, and presented early. Six passengers,
              six bags, one chauffeur included.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 pb-28 sm:px-8 lg:px-12">
        <div className="grid gap-8 md:grid-cols-2">
          {FLEET.map((v, i) => (
            <Reveal key={v.id} delay={(i % 2) * 0.1}>
              <SpotlightCard
                className="group h-full overflow-hidden rounded-2xl border border-gold/15 bg-obsidian-800 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-gold/10"
                data-testid={`fleet-card-${v.id}`}
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={v.img}
                    alt={v.name}
                    className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-obsidian-900/80 via-transparent to-transparent" />
                  <div className="absolute bottom-4 left-5 flex gap-2">
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-obsidian-900/80 px-3 py-1.5 font-mono text-[10px] tracking-[0.14em] text-gold backdrop-blur">
                      <Users className="h-3 w-3" /> {v.pax} PAX
                    </span>
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-obsidian-900/80 px-3 py-1.5 font-mono text-[10px] tracking-[0.14em] text-gold backdrop-blur">
                      <Luggage className="h-3 w-3" /> {v.bags} BAGS
                    </span>
                  </div>
                </div>
                <div className="p-8">
                  <h2 className="font-display text-3xl font-semibold text-ivory">
                    {v.name}
                  </h2>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-gold/80">
                    {v.models}
                  </p>
                  <p className="mt-4 text-sm leading-relaxed text-ivory/70">
                    {v.blurb}
                  </p>
                  <ul className="mt-5 flex flex-wrap gap-2">
                    {v.tags.map((t) => (
                      <li
                        key={t}
                        className="rounded-full border border-gold/20 px-3 py-1 text-[11px] text-ivory/65"
                      >
                        {t}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/reservation"
                    data-testid={`fleet-reserve-${v.id}`}
                    className="group/btn mt-7 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-gold"
                  >
                    Reserve this vehicle
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5" />
                  </Link>
                </div>
              </SpotlightCard>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12">
          <p className="text-center font-mono text-[11px] uppercase tracking-[0.2em] text-ivory/40">
            Larger group? Both Suburbans can be booked together for up to
            twelve passengers.
          </p>
        </Reveal>
      </section>
    </main>
  );
}
